import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default defineComponent({
  name: 'SDGList',
  props: {
    primarySdgs: Array,
    secondarySdgs: Array,
    shortList: Boolean,
    maxSDGs: Number
  },
  computed: {
    shownPrimarySdgs: function shownPrimarySdgs() {
      if (!this.primarySdgs) {
        return [];
      }
      var unique = _toConsumableArray(new Set(this.primarySdgs));
      if (this.shortList) {
        return unique.slice(0, 3);
      }
      return unique;
    },
    shownSecondarySdgs: function shownSecondarySdgs() {
      if (!this.secondarySdgs) {
        return [];
      }
      var unique = _toConsumableArray(new Set(this.secondarySdgs));
      if (this.shortList) {
        var max = Math.max(3 - this.primarySdgs.length, 0);
        return unique.slice(0, max);
      }
      return unique;
    }
  }
});